import React, { useContext, useState } from "react";
import styles from "./Cover.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
import Btn from '../Btn';
const Cover = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { isMobile, updatePage } = state;
  const [isTransition, setTransition] = useState(false);
  const clickHandler = () => {
    if (isTransition) return;
    setTransition(true);
    updatePage(prev => prev + 1);
  }
  return (
    <>
      <div className={styles.wrap}>
        <h1 className={styles.title}>Хорошо ли вы знакомы с самим собой?</h1>
        <div className={styles.text}>
          {isMobile ?
            'Пройдите короткий тест с нестандартными вопросами и узнайте, кто вы по духу и сути — креатор, визионер, исследователь или всего понемногу. '
            :
            'Пройдите короткий тест с нестандартными вопросами и узнайте, кто вы по духу и сути — креатор, визионер, исследователь или всего понемногу. Зная больше о себе, проще находить баланс, получать удовольствие от работы, хобби, общения.'
          }
        </div>
        <div className={styles.btn} onClick={clickHandler}>
          <Btn theme={'main'}>Погрузиться в себя</Btn>
        </div>
      </div>
    </>
  );

}

export default Cover;
